"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9721],{

/***/ 83955:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ fetchFollowingFeeds; },
/* harmony export */   "g": function() { return /* binding */ fetchHomeFeeds; }
/* harmony export */ });
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(39322);
/* harmony import */ var _utils_misc__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(45874);
/* harmony import */ var _chatbot__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(23082);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};



var _populate = function(feeds, type, objects) {
    return feeds.map(function(item) {
        var object = objects.find(function(s) {
            return s.id === item.objectId && type === item.objectType;
        });
        if (object) {
            return _objectSpreadProps(_objectSpread({}, item), {
                id: "".concat(item.objectType, "-").concat(item.objectId),
                object: object
            });
        }
        return _objectSpreadProps(_objectSpread({}, item), {
            id: "".concat(item.objectType, "-").concat(item.objectId)
        });
    });
};
var fetchFollowingFeeds = function() {
    var _ref = _asyncToGenerator(function() {
        var page, perPage, data, storyIds, postIds, feeds, ref, stories, ref1, posts;
        var _arguments = arguments;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    page = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : 1, perPage = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : 20;
                    return [
                        4,
                        ___WEBPACK_IMPORTED_MODULE_0__/* .api.get */ .hi.get("/users/me/following-feeds/".concat((0,_utils_misc__WEBPACK_IMPORTED_MODULE_1__/* .toQueryString */ .UK)({
                            page: page,
                            perPage: perPage
                        })))
                    ];
                case 1:
                    data = _state.sent().data;
                    storyIds = data.items.filter(function(item) {
                        return item.objectType === "story";
                    }).map(function(item) {
                        return item.objectId;
                    });
                    postIds = data.items.filter(function(item) {
                        return item.objectType === "community";
                    }).map(function(item) {
                        return item.objectId;
                    });
                    feeds = data.items;
                    if (!(storyIds.length > 0)) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        ___WEBPACK_IMPORTED_MODULE_0__/* .api.get */ .hi.get("/stories/".concat((0,_utils_misc__WEBPACK_IMPORTED_MODULE_1__/* .toQueryString */ .UK)({
                            storyIds: storyIds.join(",")
                        })))
                    ];
                case 2:
                    ref = _state.sent(), stories = ref.data;
                    feeds = _populate(feeds, "story", stories);
                    _state.label = 3;
                case 3:
                    if (!(postIds.length > 0)) return [
                        3,
                        5
                    ];
                    return [
                        4,
                        ___WEBPACK_IMPORTED_MODULE_0__/* .api.get */ .hi.get("/communities/".concat((0,_utils_misc__WEBPACK_IMPORTED_MODULE_1__/* .toQueryString */ .UK)({
                            communityIds: postIds.join(",")
                        })))
                    ];
                case 4:
                    ref1 = _state.sent(), posts = ref1.data;
                    feeds = _populate(feeds, "community", posts);
                    _state.label = 5;
                case 5:
                    return [
                        2,
                        _objectSpreadProps(_objectSpread({}, data), {
                            items: feeds
                        })
                    ];
            }
        });
    });
    return function fetchFollowingFeeds() {
        return _ref.apply(this, arguments);
    };
}();
var _populateHome = function(feeds, objects) {
    return feeds.map(function(item) {
        var object = objects.find(function(s) {
            return s.id === item.media_id;
        });
        if (object) {
            return _objectSpreadProps(_objectSpread({}, item), {
                post: object
            });
        }
        return item;
    });
};
var fetchHomeFeeds = function() {
    var _ref = _asyncToGenerator(function(feed_code, query) {
        var page, perPage, data, result, groundIds, feeds, data1;
        var _arguments = arguments;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    page = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : 1, perPage = _arguments.length > 3 && _arguments[3] !== void 0 ? _arguments[3] : 20;
                    return [
                        4,
                        _chatbot__WEBPACK_IMPORTED_MODULE_2__/* .CHAT_BOT_API.get */ .kq.get(query ? "/character-feeds/".concat(feed_code, "/").concat(query, "&page=").concat(page, "&per_page=").concat(perPage) : "/character-feeds/".concat(feed_code, "/").concat((0,_utils_misc__WEBPACK_IMPORTED_MODULE_1__/* .toQueryString */ .UK)({
                            page: page,
                            perPage: perPage
                        })))
                    ];
                case 1:
                    data = _state.sent().data;
                    result = data.result;
                    groundIds = result.items.filter(function(item) {
                        return item.media_type === "playground";
                    }).map(function(item) {
                        return item.media_id;
                    });
                    feeds = result.items;
                    if (!(groundIds.length > 0)) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        ___WEBPACK_IMPORTED_MODULE_0__/* .api.get */ .hi.get("/play/characters/all/communities/".concat((0,_utils_misc__WEBPACK_IMPORTED_MODULE_1__/* .toQueryString */ .UK)({
                            community_ids: groundIds.join(",")
                        })))
                    ];
                case 2:
                    data1 = _state.sent().data;
                    feeds = _populateHome(feeds, data1.items);
                    _state.label = 3;
                case 3:
                    return [
                        2,
                        _objectSpreadProps(_objectSpread({}, result), {
                            items: feeds
                        })
                    ];
            }
        });
    });
    return function fetchHomeFeeds(feed_code, query) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 93127:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ useTab; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(8683);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(11717);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(71618);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47311);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(39953);
/* harmony import */ var _hooks_useMounted__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(38464);
/* harmony import */ var chatie_design_system__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9150);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(92570);
/* harmony import */ var _components_common_Badge__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(63732);
/* harmony import */ var _styles_css__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(96964);
/* harmony import */ var _utils_localStorage__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(48163);
/* harmony import */ var _utils_query__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(96261);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  border-radius: 8px;\n  height: 14px;\n  width: 14px;\n  text-align: center;\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  margin-left: 4px;\n  align-self: center;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  border-radius: 8px;\n  height: 15px;\n  width: 23px;\n  text-align: center;\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  margin-left: 4px;\n  align-self: center;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n        display: flex;\n\n        button {\n          flex-basis: 0;\n        }\n      "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n      background-color: ",
        ";\n      ",
        ";\n      overflow: auto;\n      white-space: nowrap;\n      z-index: 9;\n      display: inline-flex;\n      padding: ",
        "px ",
        "px ",
        "px\n        ",
        "px;\n      align-items: flex-start;\n      gap: 10px;\n\n      ",
        "\n\n      &::-webkit-scrollbar {\n        display: none;\n      }\n\n      .tab-badge {\n        height: 30px;\n        padding: ",
        "px ",
        "px;\n        display: inline-flex;\n        align-items: center;\n        border-radius: 5px;\n      }\n      .active-tab-badge {\n        border: none;\n      }\n      .unactivate-tab-badge {\n        border: 1px solid ",
        ";\n      }\n    "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n              position: sticky;\n              top: 0;\n              ",
        "\n            "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n        display: flex;\n\n        button {\n          flex-basis: 0;\n        }\n      "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n      ",
        "\n\n      background-color: ",
        ";\n      ",
        ";\n      overflow: auto;\n      white-space: nowrap;\n      z-index: 9;\n\n      .peek-tab {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        text-align: center;\n      }\n\n      ",
        "\n\n      &::-webkit-scrollbar {\n        display: none;\n      }\n    "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n      flex-grow: 1;\n    "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n          color: ",
        ";\n          border-bottom: 2px solid ",
        ";\n          font-weight: 600;\n        "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n          color: ",
        ";\n          border-bottom: 2px solid transparent;\n        "
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _taggedTemplateLiteral([
        "\n    font-size: ",
        "px;\n    height: 42px;\n    padding: 0 ",
        "px;\n\n    ",
        "\n\n    ",
        "\n  "
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}











var badgeCSS = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_8__.css)(_templateObject());
var dateBadgeCSS = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_8__.css)(_templateObject1());
var badgeTabWrapperCSS = function(isFit, hideBorder) {
    return function(theme) {
        return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_8__.css)(_templateObject3(), theme.var.white, !hideBorder && "border-bottom: 1px solid ".concat(theme.border.light), chatie_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Spacing.medium */ .Ki.medium, chatie_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Spacing.small */ .Ki.small, chatie_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Spacing.xsmall */ .Ki.xsmall, chatie_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Spacing.small */ .Ki.small, isFit && (0,_emotion_react__WEBPACK_IMPORTED_MODULE_8__.css)(_templateObject2()), chatie_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Spacing.xsmall */ .Ki.xsmall, chatie_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Spacing.small */ .Ki.small, theme.var.gray200);
    };
};
var tabWrapperCSS = function(isFit, top, hideBorder, topSafeAreaMode, stickyEnabled) {
    return function(theme) {
        return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_8__.css)(_templateObject6(), stickyEnabled && (top > 0 ? (0,_styles_css__WEBPACK_IMPORTED_MODULE_5__/* .sticky */ .CA)(top) : topSafeAreaMode === "offset" ? (0,_styles_css__WEBPACK_IMPORTED_MODULE_5__/* .sticky */ .CA)(0) : (0,_emotion_react__WEBPACK_IMPORTED_MODULE_8__.css)(_templateObject4(), (0,_styles_css__WEBPACK_IMPORTED_MODULE_5__/* .safeArea */ .BI)("top"))), theme.var.white, !hideBorder && "border-bottom: 1px solid ".concat(theme.border.light), isFit && (0,_emotion_react__WEBPACK_IMPORTED_MODULE_8__.css)(_templateObject5()));
    };
};
var tabCSS = function(isActive, isFit) {
    return function(theme) {
        return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_8__.css)(_templateObject10(), chatie_design_system__WEBPACK_IMPORTED_MODULE_3__/* .FontSizes.small */ .TS.small, chatie_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Spacing.medium */ .Ki.medium, isFit && (0,_emotion_react__WEBPACK_IMPORTED_MODULE_8__.css)(_templateObject7()), isActive ? (0,_emotion_react__WEBPACK_IMPORTED_MODULE_8__.css)(_templateObject8(), theme.var.black, theme.var.black) : (0,_emotion_react__WEBPACK_IMPORTED_MODULE_8__.css)(_templateObject9(), theme.var.gray500));
    };
};
var Tab = function(param) {
    var className = param.className, tabs = param.tabs, activeTab = param.activeTab, _fit = param.fit, fit = _fit === void 0 ? false : _fit, _stickyAt = param.stickyAt, stickyAt = _stickyAt === void 0 ? 44 : _stickyAt, onChange = param.onChange, _hideBorder = param.hideBorder, hideBorder = _hideBorder === void 0 ? false : _hideBorder, _type = param.type, type = _type === void 0 ? "default" : _type, lastPeekTabViewDate = param.lastPeekTabViewDate, _topSafeAreaMode = param.topSafeAreaMode, topSafeAreaMode = _topSafeAreaMode === void 0 ? "padding" : _topSafeAreaMode, _sticky = param.sticky, sticky = _sticky === void 0 ? true : _sticky;
    var ref = (0,_components_common_Badge__WEBPACK_IMPORTED_MODULE_4__/* .useBadgePresets */ .fw)(), newbadge = ref.new;
    var theme = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_9__.u)();
    var randomNum = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return Math.floor(Math.random() * (50 - 20) + 20);
    }, []);
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isShowRandomNumber = ref1[0], setIsShowRandomNumber = ref1[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var lastDate = lastPeekTabViewDate ? new Date(lastPeekTabViewDate) : undefined;
        if (lastDate) {
            lastDate === null || lastDate === void 0 ? void 0 : lastDate.setHours((lastDate === null || lastDate === void 0 ? void 0 : lastDate.getHours()) + 6);
        }
        var now = new Date();
        var isShowRandomNumber = activeTab !== "home_peek" && (!lastDate || (0,date_fns__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(now, lastDate));
        setIsShowRandomNumber(isShowRandomNumber);
    }, []);
    if (type === "badge") {
        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("div", {
            css: badgeTabWrapperCSS(fit, hideBorder),
            className: "".concat(className, " ").concat(activeTab),
            children: tabs.map(function(tab) {
                return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(_components_common_Badge__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP, {
                    className: "tab-badge ".concat(tab.value === activeTab ? "active-tab-badge" : "unactivate-tab-badge"),
                    text: tab.value,
                    onClick: function() {
                        return onChange === null || onChange === void 0 ? void 0 : onChange(tab.value);
                    },
                    backgroundColor: tab.value === activeTab ? theme.colors.main500 : theme.true.white,
                    color: tab.value === activeTab ? theme.true.white : theme.true.black,
                    radius: 5,
                    fontSize: 14
                });
            })
        });
    }
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("div", {
        css: tabWrapperCSS(fit, stickyAt, hideBorder, topSafeAreaMode, sticky),
        className: className,
        children: tabs.map(function(tab) {
            if (tab.value === "chat-library") {
                return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("button", {
                    css: tabCSS(tab.value === activeTab, fit),
                    onClick: function() {
                        return onChange === null || onChange === void 0 ? void 0 : onChange(tab.value);
                    },
                    children: [
                        tab.label,
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(_components_common_Badge__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP, _objectSpreadProps(_objectSpread({
                            text: "N"
                        }, newbadge), {
                            css: badgeCSS
                        }))
                    ]
                }, "tab-".concat(tab.label));
            }
            if (tab.value === "home_peek") {
                return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("button", {
                        className: "peek-tab",
                        css: tabCSS(tab.value === activeTab, fit),
                        onClick: function() {
                            return onChange === null || onChange === void 0 ? void 0 : onChange(tab.value);
                        },
                        children: [
                            tab.label,
                            isShowRandomNumber && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(_components_common_Badge__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP, _objectSpreadProps(_objectSpread({
                                text: "".concat(randomNum)
                            }, newbadge), {
                                css: dateBadgeCSS
                            }))
                        ]
                    })
                }, "tab-".concat(tab.label));
            }
            return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("button", {
                css: tabCSS(tab.value == activeTab, fit),
                onClick: function() {
                    return onChange === null || onChange === void 0 ? void 0 : onChange(tab.value);
                },
                children: tab.label
            }, "tab-".concat(tab.label));
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Tab);
var useTab = function(tabs) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
        replace: false,
        withoutReRendering: false,
        refresh: false,
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        onClickTab: function() {}
    };
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)();
    var isMounted = (0,_hooks_useMounted__WEBPACK_IMPORTED_MODULE_2__/* .useMounted */ .s)();
    var replace = options.replace, withoutReRendering = options.withoutReRendering;
    var currentTab = router.query.tab;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(undefined), lastPeekTabViewDate = ref[0], setLastPeekTabViewDate = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(currentTab || tabs[0].value), activeTab = ref1[0], setActiveTab = ref1[1];
    var onChange = function(tab) {
        var ref;
        options === null || options === void 0 ? void 0 : (ref = options.onClickTab) === null || ref === void 0 ? void 0 : ref.call(options, tab);
        if (tab === "home_peek") {
            var date = new Date();
            setLastPeekTabViewDate(date);
            _utils_localStorage__WEBPACK_IMPORTED_MODULE_6__/* .ParsedStorage.setItem */ .f.setItem("lastPeekTabViewDate", date);
        }
        if ((options === null || options === void 0 ? void 0 : options.refresh) && tab === activeTab) {
            return window.location.reload();
        }
        (0,react__WEBPACK_IMPORTED_MODULE_1__.startTransition)(function() {
            setActiveTab(tab);
        });
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (!isMounted) {
            return;
        }
        if (activeTab && replace && !withoutReRendering) {
            router.replace({
                query: _objectSpreadProps(_objectSpread({}, router.query), {
                    tab: activeTab
                })
            }, undefined, {
                shallow: true,
                scroll: false
            });
        } else if (withoutReRendering) {
            (0,_utils_query__WEBPACK_IMPORTED_MODULE_7__/* .changeQueryWithoutRendering */ .Gu)(_objectSpreadProps(_objectSpread({}, router.query), {
                tab: activeTab
            }));
        }
    }, [
        activeTab
    ]);
    return {
        tabs: tabs,
        activeTab: activeTab,
        onChange: onChange,
        lastPeekTabViewDate: lastPeekTabViewDate,
        setLastPeekTabViewDate: setLastPeekTabViewDate
    };
};


/***/ }),

/***/ 45861:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8683);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11717);
/* harmony import */ var chatie_design_system__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9150);
/* harmony import */ var _styles_css__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96964);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  max-width: inherit;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var safeareaCSS = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_2__.css)(_templateObject());
var SafeArea = function(param) {
    var className = param.className, top = param.top, bottom = param.bottom, children = param.children;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
        className: className,
        css: [
            safeareaCSS,
            top ? (0,_styles_css__WEBPACK_IMPORTED_MODULE_1__/* .safeArea */ .BI)("top") : undefined,
            bottom ? (0,_styles_css__WEBPACK_IMPORTED_MODULE_1__/* .safeArea */ .BI)("bottom", "padding", chatie_design_system__WEBPACK_IMPORTED_MODULE_0__/* .Spacing.medium */ .Ki.medium) : undefined, 
        ],
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SafeArea);


/***/ })

}]);